import React from 'react';

interface WooCommerceLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const WooCommerceLogo: React.FC<WooCommerceLogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <svg
        viewBox="0 0 100 100"
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background circle (white) */}
        <circle cx="50" cy="50" r="48" fill="white" stroke="#e5e7eb" strokeWidth="1"/>
        
        {/* Speech bubble background (purple) */}
        <path
          d="M 25 35 Q 25 25 35 25 L 65 25 Q 75 25 75 35 L 75 55 Q 75 65 65 65 L 50 65 L 45 70 L 50 65 L 35 65 Q 25 65 25 55 Z"
          fill="#7c3aed"
        />
        
        {/* Speech bubble pointer */}
        <path
          d="M 50 65 L 45 70 L 50 75 Z"
          fill="#7c3aed"
        />
        
        {/* "Woo" text */}
        <text
          x="50"
          y="50"
          textAnchor="middle"
          fontSize="24"
          fontWeight="bold"
          fill="white"
          fontFamily="Arial, sans-serif"
        >
          Woo
        </text>
      </svg>
    </div>
  );
};

export default WooCommerceLogo;




